import { Stack, Typography, useColorScheme } from "@mui/material";
import BorderWidget from "./border_widget";
import { Constants } from "../../utils/constants";
import { LineChart } from "@mui/x-charts";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import moment from "moment";

function CustomTooltip({ axisValue, series }) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";

    if (!series || series.length === 0) return null;

    return (
        <div style={{
            backgroundColor: Constants.Colors[currentMode].background,
            border: `1px solid ${Constants.Colors[currentMode].border}`,
            borderRadius: Constants.Styles.radius.base,
            padding: "0.5rem"
        }}>
            <Typography sx={{ color: Constants.Colors[currentMode].foreground, fontSize: Constants.Styles.fontSize.base }}>
                {moment(axisValue).format("MMM DD")}
            </Typography>
            {series.map((item, index) => (
                <Typography key={index} sx={{ color: Constants.Colors[currentMode].accent, fontSize: Constants.Styles.fontSize.base, fontWeight: Constants.Styles.fontWeight.medium }}>
                    Redirects: {item.value}
                </Typography>
            ))}
        </div>
    );
}

export default function ProjectDetailChart({ data }) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    return (
        <BorderWidget sx={{
            boxShadow: "0px 1px 3px 0px #0000001a",
        }}>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}
                sx={{
                    paddingInline: "1rem",
                    paddingBlock: "1rem",
                }}
            >
                <Typography sx={{
                    fontSize: Constants.Styles.fontSize.base,
                    fontWeight: Constants.Styles.fontWeight.medium,
                }}>
                    Redirects Over Time
                </Typography>
                <Stack direction={"row"} alignItems={"center"} spacing={0.3}>
                    <FiberManualRecordIcon sx={{ color: Constants.Colors[currentMode].accent, fontSize: "0.75rem" }} />
                    <Typography sx={{
                        fontSize: Constants.Styles.fontSize.xs,
                    }}>
                        Redirects
                    </Typography>
                </Stack>
            </Stack>
            <LineChart
                xAxis={[{
                    dataKey: "timestamp",
                    data: data[0],
                    scaleType: "time",
                    valueFormatter: (value) => moment(value).format("MMM DD"),
                    // hideTooltip: true,
                }]}
                series={[
                    {
                        data: data[1],
                        color: Constants.Colors[currentMode].accent,
                        showMark: false,
                        valueFormatter: (value) => (`${value} redirects`),
                        disableHighlight: false,
                    },
                ]}
                height={300}
                grid={{ horizontal: true }}
                sx={{
                    '& .MuiChartsGrid-line': {
                        strokeDasharray: '3 3',
                        strokeWidth: 2,
                        stroke: Constants.Colors[currentMode].border,
                    },
                    '& .MuiChartsAxis-bottom .MuiChartsAxis-line': {
                        stroke: Constants.Colors[currentMode].accent,
                        strokeWidth: 0,
                    },
                    '& .MuiChartsAxis-bottom .MuiChartsAxis-tick': {
                        stroke: Constants.Colors[currentMode].background,
                    },
                    '& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel': {
                        fill: Constants.Colors[currentMode].mutedForeground,
                    },

                    '& .MuiChartsAxis-left .MuiChartsAxis-line': {
                        stroke: Constants.Colors[currentMode].foreground,
                        strokeWidth: 0,
                    },
                    '& .MuiChartsAxis-left .MuiChartsAxis-tick': {
                        stroke: Constants.Colors[currentMode].background,
                    },
                    '& .MuiChartsAxis-left .MuiChartsAxis-tickLabel': {
                        fill: Constants.Colors[currentMode].mutedForeground,
                    },
                }}
            />
        </BorderWidget>
    );
}